export const FETCH_TRANSFER_ORDER_LIST_PENDING = "FETCH_TRANSFER_ORDER_LIST_PENDING";
export const FETCH_TRANSFER_ORDER_LIST_REJECTED = "FETCH_TRANSFER_ORDER_LIST_REJECTED";
export const FETCH_TRANSFER_ORDER_LIST_FULFILLED = "FETCH_TRANSFER_ORDER_LIST_FULFILLED";
export const START_TRANSFER_ORDER_LIST_AUTO_RELOAD = "START_TRANSFER_ORDER_LIST_AUTO_RELOAD";
export const STOP_TRANSFER_ORDER_LIST_AUTO_RELOAD = "STOP_TRANSFER_ORDER_LIST_AUTO_RELOAD";
export const SET_ACTIVE_STATUS_FOR_TRANSFER_ORDER_LIST = "SET_ACTIVE_STATUS_FOR_TRANSFER_ORDER_LIST";
export const CLEAR_TRANSFER_ORDER_LIST = "CLEAR_TRANSFER_ORDER_LIST";


// WEBPACK FOOTER //
// ./src/constants/kapidaConstants/transferOrderList.js